import { CALL_API, HTTP_METHODS } from "../../../../../setup/constants";
import * as ACTIONS from "../constants";

export const copyProgram = (payload) => ({
  type: ACTIONS.COPY_PROGRAM,
  payload,
});

export const clearStore = () => ({
  type: ACTIONS.CLEAR_PROGRAM_STORE,
});

export const programsSort = (payload) => ({
  type: ACTIONS.PROGRAMS_SORT,
  payload,
});

export const downloadPrograms = (params) => ({
  type: CALL_API,
  meta: {
    actions: {
      init: ACTIONS.DOWNLOAD_PROGRAMS_INIT,
      success: ACTIONS.DOWNLOAD_PROGRAMS_SUCCEDED,
      fail: ACTIONS.DOWNLOAD_PROGRAMS_FAILED,
    },
    endpoint: ACTIONS.ENDPOINT_DOWNLOAD_PROGRAMS,
    method: HTTP_METHODS.GET,
    extra: {
      responseType: "blob",
    },
    headers: {
      "Content-Disposition": "attachment; filename=programations.xlsx",
    },
    params,
    auth: true,
  },
});

export const fetchPrograms = (params) => ({
  type: CALL_API,
  meta: {
    actions: {
      init: ACTIONS.FETCH_PROGRAMS_INIT,
      success: ACTIONS.FETCH_PROGRAMS_SUCCEDED,
      fail: ACTIONS.FETCH_PROGRAMS_FAILED,
    },
    endpoint: ACTIONS.ENDPOINT_PROGRAMS,
    method: HTTP_METHODS.GET,
    params,
    auth: true,
  },
});

export const fetchProgram = (param) => ({
  type: CALL_API,
  meta: {
    actions: {
      init: ACTIONS.FETCH_PROGRAM_INIT,
      success: ACTIONS.FETCH_PROGRAM_SUCCEDED,
      fail: ACTIONS.FETCH_PROGRAM_FAILED,
    },
    endpoint: ACTIONS.ENDPOINT_PROGRAM.replace(":param", param),
    method: HTTP_METHODS.GET,
    auth: true,
  },
});

export const createProgram = (payload) => ({
  type: CALL_API,
  payload,
  meta: {
    actions: {
      init: ACTIONS.CREATE_PROGRAM_INIT,
      success: ACTIONS.CREATE_PROGRAM_SUCCEDED,
      fail: ACTIONS.CREATE_PROGRAM_FAILED,
    },
    endpoint: ACTIONS.ENDPOINT_PROGRAMS,
    method: HTTP_METHODS.POST,
    auth: true,
  },
});

export const updateProgram = (payload, param) => {
  return {
    type: CALL_API,
    payload,
    meta: {
      actions: {
        init: ACTIONS.UPDATE_PROGRAM_INIT,
        success: ACTIONS.UPDATE_PROGRAM_SUCCEDED,
        fail: ACTIONS.UPDATE_PROGRAM_FAILED,
      },
      endpoint: ACTIONS.ENDPOINT_PROGRAM.replace(":param", param),
      method: HTTP_METHODS.PUT,
      auth: true,
    },
  };
};

export const duplicateProgram = (payload) => ({
  type: CALL_API,
  payload,
  meta: {
    actions: {
      init: ACTIONS.DUPLICATE_PROGRAM_INIT,
      success: ACTIONS.DUPLICATE_PROGRAM_SUCCEDED,
      fail: ACTIONS.DUPLICATE_PROGRAM_FAILED,
    },
    endpoint: ACTIONS.ENDPOINT_PROGRAM.replace(":param", "duplicate"),
    method: HTTP_METHODS.POST,
    auth: true,
  },
});

export const deleteProgram = (param) => ({
  type: CALL_API,
  meta: {
    actions: {
      init: ACTIONS.DELETE_PROGRAM_INIT,
      success: ACTIONS.DELETE_PROGRAM_SUCCEDED,
      fail: ACTIONS.DELETE_PROGRAM_FAILED,
    },
    endpoint: ACTIONS.ENDPOINT_PROGRAM.replace(":param", param),
    method: HTTP_METHODS.DELETE,
    auth: true,
  },
});

export const addParticipation = (payload) => ({
  type: CALL_API,
  payload,
  meta: {
    actions: {
      init: ACTIONS.ADD_PARTICIPATION_INIT,
      success: ACTIONS.ADD_PARTICIPATION_SUCCEDED,
      fail: ACTIONS.ADD_PARTICIPATION_FAILED,
    },
    endpoint: ACTIONS.ENDPOINT_PARTICIPATIONS,
    method: HTTP_METHODS.POST,
    auth: true,
  },
});

export const updatePresence = (param, payload) => ({
  type: CALL_API,
  payload,
  meta: {
    actions: {
      init: ACTIONS.UPDATE_PARTICIPATION_INIT,
      success: ACTIONS.UPADTE_PARTICIPATION_SUCCEDED,
      fail: ACTIONS.UPDATE_PARTICIPATION_FAILED,
    },
    endpoint: ACTIONS.ENDPOINT_PARTICIPATION.replace(":param", param),
    method: HTTP_METHODS.PUT,
    auth: true,
  },
});

export const uploadImage = (payload) => ({
  type: CALL_API,
  payload,
  meta: {
    actions: {
      init: ACTIONS.UPLOAD_IMAGE_INIT,
      success: ACTIONS.UPLOAD_IMAGE_SUCCEDED,
      fail: ACTIONS.UPLOAD_IMAGE_FAILED,
    },
    endpoint: ACTIONS.ENDPOINT_UPLOAD,
    method: HTTP_METHODS.POST,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    auth: true,
  },
});

export const resetImage = () => ({
  type: ACTIONS.UPLOAD_IMAGE_RESET,
});

export const resetProgramFiltersBar = (payload) => ({
  type: ACTIONS.RESET_FILTERS,
  payload,
});

export const removeParticipationAdmin = (params) => ({
  type: CALL_API,
  meta: {
    actions: {
      init: ACTIONS.REMOVE_PARTICIPATION_ADMIN_INIT,
      success: ACTIONS.REMOVE_PARTICIPATION_ADMIN_SUCCEDED,
      fail: ACTIONS.REMOVE_PARTICIPATION_ADMIN_FAILED,
    },
    endpoint: ACTIONS.ENDPOINT_PARTICIPATIONS,
    method: HTTP_METHODS.DELETE,
    params,
    auth: true,
  },
});
